(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Eventproduct"] && !Shopify.designMode) return;
  try {
    
  function initializeWarsSections(scope) {
    const root = scope || document;
    const sections = root.matches && root.matches('[data-wars-event]')
      ? [root]
      : root.querySelectorAll('[data-wars-event]:not([data-wars-ready])');

    sections.forEach((section) => {
      if (section.dataset.warsReady) return;
      section.dataset.warsReady = 'true';

      const countdown = section.querySelector('[data-wars-countdown]');
      if (countdown) {
        const deadline = new Date(countdown.dataset.deadline).getTime();
        if (!Number.isFinite(deadline)) {
          countdown.hidden = true;
        } else {
          const offer = countdown.closest('[data-wars-offer]');
          const label = offer ? offer.querySelector('[data-wars-offer-label]') : null;
          let timer;
          const updateCountdown = () => {
            const remaining = deadline - Date.now();
            if (remaining <= 0) {
              countdown.hidden = true;
              if (label && offer.dataset.expiredText) label.textContent = offer.dataset.expiredText;
              if (timer) window.clearInterval(timer);
              return;
            }
            countdown.querySelector('[data-days]').textContent = String(Math.floor(remaining / 86400000)).padStart(2, '0');
            countdown.querySelector('[data-hours]').textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
            countdown.querySelector('[data-minutes]').textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
            countdown.querySelector('[data-seconds]').textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
          };
          updateCountdown();
          timer = window.setInterval(updateCountdown, 1000);
        }
      }

      const form = section.querySelector('.wars-native-form');
      if (!form) return;
      const radios = form.querySelectorAll('input[name="id"]');
      const quantity = form.querySelector('input[name="quantity"]');
      const button = form.querySelector('.wars-add-button');
      const buttonText = form.querySelector('[data-wars-button-text]');
      if (!button || !buttonText) return;

      const formatter = new Intl.NumberFormat(section.dataset.locale || 'en-US', {
        style: 'currency',
        currency: section.dataset.currency || 'USD'
      });

      const updateButton = () => {
        const selected = form.querySelector('input[name="id"]:checked');
        const amount = selected ? Number(selected.dataset.price || 0) : 0;
        const count = Math.max(1, Number(quantity ? quantity.value : 1) || 1);
        if (!selected || selected.disabled) {
          button.disabled = true;
          buttonText.textContent = button.dataset.soldOutLabel || 'Sold out';
          return;
        }
        button.disabled = false;
        buttonText.textContent = `${button.dataset.addLabel || 'Add tickets'} — ${formatter.format((amount * count) / 100)}`;
      };

      radios.forEach((radio) => radio.addEventListener('change', updateButton));
      if (quantity) quantity.addEventListener('input', updateButton);
      updateButton();
    });
  }

  initializeWarsSections(document);
  document.addEventListener('shopify:section:load', (event) => initializeWarsSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
